




























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import CardInfo from '@/components/common/CardInfo.vue';
import LazyImg from '@/components/common/LazyImg.vue';

import SpeciesSpotlightImg from '@/assets/images/species-spotlight.jpeg';

import { SurveyProperty, FaunaStats } from '@/api';
import cacheModule from '@/store/Cache';
import { useSpraypaintCache } from '@/cacheUtil';

@Component({
  components: {
    LazyImg,
    CardInfo,
  },
})
export default class SpeciesSpotlight extends Vue {
  @Prop({ default: null }) readonly property: SurveyProperty | null;

  loading = false;

  index = 0;

  foundTagsIds: number[] = [];

  get placeholderImg() {
    return SpeciesSpotlightImg;
  }

  get foundTags() {
    // only show tags with descriptions
    return this.foundTagsIds
      .map(id => cacheModule.faunaTagsById(id.toString()))
      .filter(ft => {
        return ft && !!ft.description && ft.description !== '<p></p>';
      });
  }

  get selectedTag() {
    return this.foundTags[this.index];
  }

  prev() {
    this.index = Math.max(0, this.index - 1);
  }

  next() {
    this.index = (this.index + 1) % this.foundTags.length;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  shuffleArray(array: any[]) {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }

  async getSpeciesStats() {
    try {
      this.loading = true;
      const id = this.property ? (this.property.id as string) : undefined;
      const speciesStats = await useSpraypaintCache(
        FaunaStats.where({
          survey_property__in: id,
          // TODO: this doesnt work
          // tagger_type__in: TaggerType.ai,
          group_by: ['fauna_tag'],
        }),
      ).then(r => r.data);

      this.foundTagsIds = this.shuffleArray(
        speciesStats.map(s => s.faunaTag).filter(s => typeof s === 'number'),
      );
    } finally {
      this.loading = false;
    }
  }

  mounted() {
    this.getSpeciesStats();
  }
}
